export default __webpack_public_path__ + "static/lesson-en@2x-e467b1b4cee95a479b28d63989eba65f.png";